import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import HeadShake from "react-reveal/HeadShake";
//? Styles
import { styleScreenDashboard } from "../styles/style";
import "../styles/style.css";
// ? Components
//? Card order
import CardOrder from "../components/card/cardOrder";
import CardDelivery from "../components/card/cardDelivery";
//? hook to include the functions to list deliverymen and orders, subscriptions to listen updates by order
import useListDashboardData from "../hooks/useListDashboardData";
import usePushNotifications from "../hooks/usePushNotifications";
import { API, Auth, graphqlOperation } from "aws-amplify";
import { updateDeliveryStatus, updateOrder } from "../graphql/myMutations";
import ReactHowler from "react-howler";
import {
  onUpdateAccountByRole,
  onCreateWishOrder,
} from "../graphql/mySubscriptions";
import { onUpdateOrderByStatus } from "../graphql/subscriptions";
import useToCommisions from "../services/charges/useToCommisions";

import ColumOptions from "../components/columnOptions/columnOptions";
const AssignOrder = ({ messageAssignOrder, optionSideBarSelected }) => {
  const [idUserConnected, setIdUserConnected] = useState("");
  //? state for animations
  const [count, setcount] = useState(0);
  //let dealers = dealersInitialState;
  //? control if there is a card selected
  const [isSelectedAdd, setIsSelectedAdd] = useState(false);
  //? state to save the id of order selected
  const [cardOrderSelected, setCardOrderSelected] = useState("");
  const [allOrders, setAllOrders] = useState([]);
  const [dealers, setDealers] = useState([]);
  const { calculateDebts } = useToCommisions();
  const [isPlaying, setIsplaying] = useState(false);
  const [orderVehicle, setOrderVehicle] = useState("");

  //? hooks
  const {
    sortArrayDistance,
    getUpdatedOrders,
    getAllActiveDealers,
    reorderDealers,
    allDealers,
    validateOrderToAssign,
    sortArrayVehicleType,
    initialDealers,
  } = useListDashboardData();
  const { sendOneSignalNotifications } = usePushNotifications();

  useEffect(() => {
    getOrderInitial();
    setUserInfo();
  }, []);

  useEffect(() => {
    /**
     * Async function to listen updates in all orders where the level is not finished
     */
    const listeningUpdatedOrders = async () => {
      try {
        console.log("Escuchando cambios de ordenes--->");
        API.graphql(
          graphqlOperation(onUpdateOrderByStatus, { status: "LISTO" })
        ).subscribe({
          next: (data) => {
            setIsplaying(true);
            getOrderInitial();
          },
          error: (error) => console.error("Error API GRAPHQL --->", error),
        });
      } catch (error) {
        console.log("Error [listeningUpdateOrders] --->", error);
      }
    };

    const listeningCreateSpecialOrders = async () => {
      try {
        API.graphql(graphqlOperation(onCreateWishOrder)).subscribe({
          next: (data) => {
            const newOrder = data.value.data.onCreateOrder.shop_id.id;
            if (
              newOrder === "wishesff-46a4-46f1-9fc2-22a3f842f8ef" ||
              newOrder === "solutions-436l-1446-5d60-6f134564a696"
            ) {
              setIsplaying(true);
              getOrderInitial();
            }
          },
          error: (error) =>
            console.error(
              "Error API GRAPHQL [listeningCreateSpecialOrders] --->",
              error
            ),
        });
      } catch (error) {
        console.log("Error [listeningCreateSpecialOrders] ", error);
      }
    };

    listeningCreateSpecialOrders();
    listeningUpdatedOrders();
    return () => {
      setIsplaying(false);
    };
  }, []);

  useEffect(() => {
    /**
     * Async function to listen updates in all orders where the level is not finished
     */
    const listeningUpdatedAccount = async () => {
      try {
        API.graphql(
          graphqlOperation(onUpdateAccountByRole, { role: "deliveryman" })
        ).subscribe({
          next: (messageData) => {
            console.log("Cambios en cuentas de repartidores --->");
            initialDealers();
            getOrderInitial();
          },
        });
      } catch (error) {
        console.log("Error [listeningUpdatedAccount]", error);
      }
    };
    listeningUpdatedAccount();
  }, []);

  const setUserInfo = async () => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        //console.log("usuario conectado: ", user?.username);
        setIdUserConnected(user?.username);
      })
      .catch((err) => {
        console.log("Error [setUserInfo] ", err);
        setIdUserConnected("userServiceDesktop");
      });
  };

  /**
   * Permite ejecutar las funciones del hook que retornan un arreglo para las ordenes y repartidores disponibles (c/u)
   */
  async function getOrderInitial() {
    let newOrders = await getUpdatedOrders();
    let newDealers = await getAllActiveDealers();
    if (newOrders.lenght !== 0) setAllOrders(newOrders);
    if (allDealers.lenght !== 0) setDealers(allDealers);
  }
  /**\
   *
   * Función para animar y habilitar la selección de selección de delivery
   * @param {String} orderId Id de la orden seleccionada
   */
  async function selectOrder(orderId) {
    //? no hay orden seleccionada y no hay tarjeta seleccionada
    if (!isSelectedAdd && cardOrderSelected === "") {
      setIsSelectedAdd(true);
      //animate delivery
      setcount(count + 1);
      //change status in card (deliveryState)
      var positionFound = allOrders.findIndex(
        (element) => element.id === orderId
      );
      setCardOrderSelected(allOrders[positionFound]);
      setAllOrders(
        allOrders.map((order) => {
          if (order.id === allOrders[positionFound].id)
            return { ...order, deliveryState: "selected" };
          else return order;
        })
      );
      //! not correct way :( allOrders[positionFound].deliveryState = "selected";
      //? reorder the dealers to show who is the more near to the order
      let responseReorder = await reorderDealers(allOrders[positionFound]);
      //console.log("Repsonse reorder: ", responseReorder);
      //responseReorder.sort((a, b) => sortArrayDistance(a, b));
      let toOrder_vehicle = JSON.parse(allOrders[positionFound].shipping_fees);
      toOrder_vehicle?.vehicle === "c"
        ? setOrderVehicle("a")
        : setOrderVehicle(toOrder_vehicle?.vehicle);

      //change order by vehicle assignment in order
      if (toOrder_vehicle.vehicle === "c") {
        responseReorder[0].order = 3;
        responseReorder[2].order = 1;
      } else if (toOrder_vehicle.vehicle === "m") {
        responseReorder[0].order = 3;
        responseReorder[2].order = 2;
        responseReorder[1].order = 1;
      }

      responseReorder.sort((a, b) => sortArrayVehicleType(a, b));
      //console.log("Arreglo----->", responseReorder);
      //TODO ordenar por tipo de vehiculo asignado a la orden
      let toRender = [];
      responseReorder.forEach((element) => {
        let this_type = element.elements;
        this_type.sort((a, b) => sortArrayDistance(a, b));
        this_type.forEach((item) => {
          toRender.push(item);
        });
      });

      setDealers(toRender);
    }
  }

  /**
   * Función para selecciónar de delivery y asignarlo a una orden
   * @param {String} deliveryId Id del delivery
   */
  function selectDelivery(deliveryId) {
    //? una orden ha sido seleccionada para asignarle un repartidor
    if (cardOrderSelected !== "") {
      //? get info delivery by id
      var positionFound = dealers.findIndex(
        (element) => element.id === deliveryId
      );
      let currDelivery = dealers[positionFound];
      let _cashOrders = currDelivery.deliveryman_orders.items
        ? getTotalCash(currDelivery.deliveryman_orders.items)
        : 0;

      if (cardOrderSelected.method_pay === "EFECTIVO" && _cashOrders <= 500) {
        //? change status
        setDealers(
          dealers.map((dealer) => {
            if (dealer.id === dealers[positionFound].id)
              return { ...dealer, selected: true };
            else return dealer;
          })
        );
        //? asign delivery info in order
        //setCardOrderSelected({...cardOrderSelected,delivery_man_id: currDelivery, });
        //? change status in card (deliveryState)
        //setCardOrderSelected({ ...cardOrderSelected, deliveryState: "droped" });
        //? mutation allOrders
        //console.log("mutate option: ", cardOrderSelected);
        setAllOrders(
          allOrders.map((order) => {
            if (order.id === cardOrderSelected.id)
              return {
                ...order,
                delivery_man_id: currDelivery,
                deliveryState: "droped",
              };
            else return order;
          })
        );
        setIsSelectedAdd(false);
      } else {
        //? Cuando el repartidor ha cobrado más de $500 en efectivo y debe de asignarle ordenes pagadas con tarjeta
        //console.log("Error, ya no puede recibir efectivo");
        messageAssignOrder(
          "¡Oops!",
          "No se le puede asignar esta orden al repartidor por la cantidad de efectivo que ha cobrado",
          "warning"
        );
      }
      setCardOrderSelected("");
    }
  }

  const getTotalCash = (myOrders) => {
    // console.log("Por calcular total");
    let total = 0;
    let _cash = 0;
    let _card = 0;
    myOrders.forEach((element) => {
      var fees =
        element.shipping_fees !== undefined && element.shipping_fees !== null
          ? JSON.parse(element.shipping_fees)
          : {};
      var costForDistance = fees.collection
        ? fees.delivery + fees.distance + fees.collection
        : 0;

      element.method_pay === "EFECTIVO"
        ? (_cash += parseFloat(calculateDebts(costForDistance)))
        : (_card += parseFloat(calculateDebts(costForDistance)));
    });
    //console.log("Datos para asignar: " + _cash + " vs" + _card);
    return _cash;
  };

  /**
   * Función para crear la orden
   * @param {String} orderId Id de la orden
   */
  async function assignOrder(orderId) {
    //? modify order
    //? change status in order
    //testing();

    var positionFound = allOrders.findIndex(
      (element) => element.id === orderId
    );
    allOrders[positionFound].level = "EN TRANSITO";
    allOrders[positionFound].status = "EN TRANSITO";
    let toAssign = await validateOrderToAssign(allOrders[positionFound].id);

    if (toAssign) {
      //! function to asign order in DB
      updateFunctionOrder(
        allOrders[positionFound], //orden
        allOrders[positionFound].delivery_man_id.id, //id del repartidor
        true //status del repartidor
      );
    } else {
      messageAssignOrder(
        "Oops!",
        "Hubo un error al asignar al repartidor, es posible que ya haya sido asignada la orden a un repartidor",
        "warning"
      );
    }
  }

  async function cancelAssign(orderId, deliveryId) {
    var positionFoundOrder = allOrders.findIndex(
      (element) => element.id === orderId
    );
    //? set free order
    allOrders[positionFoundOrder].deliveryState = "none";
    allOrders[positionFoundOrder].delivery_man_id = {};
    //? none card selected
    setIsSelectedAdd(false);
    //? set none card order selected
    setCardOrderSelected("");
    //? set free delivery if there is assigned
    if (!!deliveryId) {
      var positionFound = dealers.findIndex(
        (element) => element.id === deliveryId
      );
      //? change status
      dealers[positionFound].selected = false;
    }
    //? reset dealers (distance and proximity status)
    await getAllActiveDealers();
    if (allDealers.lenght !== 0) setDealers(allDealers);
  }

  /**
   * Function to update the status delivery in DB
   * @param {String} deliveryID Id delivery
   * @param {Boolean} statusValue Status to change the delivery_inprocess
   */
  async function updateDeliveryStatusBD(deliveryID, statusValue) {
    try {
      var info = {
        id: deliveryID,
        delivery_inprocess: statusValue,
      };
      let result = await API.graphql(
        graphqlOperation(updateDeliveryStatus, { input: info })
      );
      if (result) {
        sendOneSignalNotifications({
          content:
            result.data.updateAccount.name +
            " recuerda que tienes 30 segundos para aceptar la orden, ¡Consúltala en la app!",
          title: "Nueva orden 🏍",
          ids: [result.data.updateAccount.id],
          channel: "new-order",
          role: "deliveryman",
        });
      }
    } catch (error) {
      messageAssignOrder(
        "Oops!",
        "Hubo un error al asignar al repartidor.",
        "warning"
      );
      console.log("Error [updateDeliveryStatusBD] ", error);
    }
  }

  /**
   * Function to update the order in DB
   * @param {Object} order Objeto con información de la orden
   */
  async function updateFunctionOrder(order, id_delivery, deliveyr_status) {
    var info = {
      id: order.id,
      status: "",
      orderDelivery_man_idId: order.delivery_man_id.id,
      history: "",
    };
    //traer la info de la orden que se encuentre ACEPTADA,asignada a mi ID como repartidor
    if (order.order_type === "PRODUCTO") {
      info.status = "EN TRANSITO";
      info.level = "EN TRANSITO";
    } else if (order.order_type === "SERVICE") {
      info.status = "EN PROCESO-S";
      info.level = "EN PROCESO";
    } else {
      //TODO
      // ? function to collect orders
    }

    //? save the change maked in History
    info.history = await updateOrderHistory(info.level, info.status, order);

    API.graphql(graphqlOperation(updateOrder, { input: info }))
      .then((response) => {
        if (!!response) {
          //? the order has been updated
          messageAssignOrder(
            "Orden asignada",
            "La orden ha sido asignada correctamente",
            "success"
          );

          //! function to update delivery in DB
          updateDeliveryStatusBD(id_delivery, deliveyr_status);
        }
      })
      .catch((error) => {
        messageAssignOrder(
          "Oops!",
          "Hubo un error al asignar al repartidor.",
          "warning"
        );
        console.log("Error: ", error);
      });
  }

  /**
   * Add a change in history of order
   * @param {String} level
   * @param {String} status
   * @param {Object} order
   * @returns New history of the order
   */
  async function updateOrderHistory(level, status, order) {
    //console.log("idUserConnected: ", idUserConnected);
    var dbRecord = [];
    var newItem = {};
    newItem = {
      change: "ASSIGMENT IN SERVICE DESKTOP",
      status: status,
      level: level,
      user: idUserConnected ?? "user_service_desktop",
      hour: convertUTCDateToLocalDate(),
    };
    try {
      if (order.history) dbRecord = JSON.parse(order?.history);
    } catch (error) {
      console.log("Error [updateOrderHistory] ", error);
    }
    dbRecord.push(newItem);

    return JSON.stringify(dbRecord);
  }

  /**
   * Function to change a date UTC to local date
   * @returns date changed to local time
   */
  function convertUTCDateToLocalDate() {
    var newDate = new Date();
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    var currentDateToString = newDate.toISOString();
    return currentDateToString;
  }

  function conditionDelivery(deliveryTransport) {
    if (
      !!cardOrderSelected &&
      cardOrderSelected.shop_comments === "SOLUTIONS"
    ) {
      //? filter delivery with order vehicle
      if (
        !!deliveryTransport &&
        deliveryTransport?.startsWith(orderVehicle.toUpperCase())
      )
        return true;
      else return false;
    } else return true;
  }

  return (
    <div className="row">
      <div className="col-10">
        <ReactHowler
          src={require("../audio/negocio.wav")}
          playing={isPlaying}
        />
        <div className="row">
          <div className="col-4">
            <Card style={styleScreenDashboard.titleColumn}>
              <Card.Body>
                <Card.Title>Repartidores</Card.Title>
              </Card.Body>
            </Card>
            <div
              className="container"
              style={styleScreenDashboard.containerColumn}
            >
              {dealers.map(
                (item, index) =>
                  !item.selected &&
                  conditionDelivery(item.delivery_transport) && (
                    <HeadShake spy={count} key={index + "dealer"}>
                      <CardDelivery
                        item={item}
                        selectDelivery={selectDelivery}
                      />
                    </HeadShake>
                  )
              )}
            </div>
          </div>
          <div className="col-8">
            <Card style={styleScreenDashboard.titleColumn}>
              <Card.Body>
                <Card.Title>
                  Ordenes por asignar: {allOrders.length}{" "}
                </Card.Title>
              </Card.Body>
            </Card>
            <div
              className="container"
              style={styleScreenDashboard.containerColumn}
            >
              {allOrders.map((order, index) => (
                <CardOrder
                  key={index + "ord"}
                  order={order}
                  selectOrder={selectOrder}
                  createOrder={assignOrder}
                  cancelAction={cancelAssign}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <ColumOptions onSelectOption={optionSideBarSelected} />
    </div>
  );
};

export default AssignOrder;
